module.exports = __webpack_public_path__ + "img/Loading-dark.779cb4b3.svg";